import Plyr from 'plyr';

export default function initSitePlyr() {

  const players = document.querySelectorAll('.js-plyr');

  players.forEach((player, idx) => {
    let plyrID;

    if ( player.getAttribute('id') ) {
      plyrID = player.getAttribute('id');
    } else {
      plyrID = `plyr-${idx}`;
    }

    new Plyr(`#${plyrID}`, {
      speed: {
        options: [0.5, 1, 1.5, 2]
      }
    });
  })
}
